import React from "react";
import styles from "./LocationAvailability.module.css"
import {WorkScheduleUi} from "../../../../../../../api/generated";
import {WorkingScheduleCard} from "./WorkingScheduleCard/WorkingScheduleCard";

interface LocationAvailabilityProps {
    workSchedule: WorkScheduleUi
}

export const LocationAvailability: React.FC<LocationAvailabilityProps> = ({
                                                                              workSchedule
                                                                          }) => {
    return <div className={styles.wrapper}>
        <span className={styles.title}>Location Availability</span>
        <div className={styles.valueWrapper}>
            <WorkingScheduleCard
                title={"Mon"}
                workingHours={workSchedule.monday}
            />
            <WorkingScheduleCard
                title={"Tue"}
                workingHours={workSchedule.tuesday}
            />
            <WorkingScheduleCard
                title={"Wed"}
                workingHours={workSchedule.wednesday}
            />
            <WorkingScheduleCard
                title={"Thu"}
                workingHours={workSchedule.thursday}
            />
            <WorkingScheduleCard
                title={"Fri"}
                workingHours={workSchedule.friday}
            />
            <WorkingScheduleCard
                title={"Sat"}
                workingHours={workSchedule.saturday}
            />
            <WorkingScheduleCard
                title={"Sun"}
                workingHours={workSchedule.sunday}
            />
        </div>
    </div>
}
